import React from 'react';
import { SkeletonTable } from '../../../../components/Skeleton/Table';

const Loading: React.FC<{ pageSize: number }> = ({ pageSize }) => (
  <SkeletonTable className="card-table" columns={5} rows={pageSize} />
);

export default Loading;
